import {
  CalculatorSection as UICalculatorSection,
  CalculatorSectionProps,
  CalculatorSlider,
  CalculatorResultItem,
  SectionBackgroundColorType,
  SectionTopPaddingSizeType,
  SectionBottomPaddingSizeType,
} from "@repo/ui-parkmobile";
import { storyblokEditable, SbBlokData } from "@storyblok/react/rsc";
import type { CalculatorSection } from "@/generated/sb";
import React from "react";
import { buttonResolver, sectionTitleResolver } from "@/lib/storyblok/adaptors";

export function CalculatorSection({
  blok,
}: {
  blok: CalculatorSection;
}) {
  const head = blok.typography
    ? sectionTitleResolver([
        {
          typography: blok.typography,
          layout: "left",
          component: "sectionTitle",
          _uid: "section-title-" + blok._uid,
        },
      ]) || undefined
    : undefined;

  const sliders: CalculatorSlider[] =
    blok.sliders?.map((slider) => ({
      title: slider.title || "",
      min: parseInt(slider.min || "1"),
      max: parseInt(slider.max || "100"),
      defaultValue: parseInt(slider.defaultValue || "25"),
    })) || [];

  const resultItems: CalculatorResultItem[] =
    blok.resultItems?.map((item) => ({
      title: "",
      subtitle: item.subtitle || "",
      description: item.description,
    })) || [];

  const calculatorProps: CalculatorSectionProps = {
    head,
    sliders,
    totalLabel: blok.resultTitle || "working days per year",
    totalUnits: "",
    resultDescription: blok.resultText,
    button: blok.button?.[0] ? buttonResolver(blok.button[0]) ?? undefined : undefined,
    resultItems,
    variant: blok.variant === "detailed" ? "detailed" : "simple",
    backgroundColor: blok.backgroundColor as SectionBackgroundColorType,
    topPadding: blok.topPadding as SectionTopPaddingSizeType,
    bottomPadding: blok.bottomPadding as SectionBottomPaddingSizeType,
  };

  return (
    <UICalculatorSection
      {...calculatorProps}
      {...storyblokEditable(blok as SbBlokData)}
      id={blok.anchor}
    />
  );
}
